import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Html5Qrcode } from 'html5-qrcode';
import { TopBar } from '../components/TopBar.js';
import { resolveQr } from '../lib/qr.js';

export function ScanPage() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Iniciando câmera…');
  const [erro, setErro] = useState('');
  const [manual, setManual] = useState('');
  const scannerRef = useRef<Html5Qrcode | null>(null);
  const handledRef = useRef(false);

  function irPara(dest: ReturnType<typeof resolveQr>) {
    if (!dest) return;
    if (dest.type === 'url') {
      try {
        const u = new URL(dest.url, window.location.origin);
        if (u.origin === window.location.origin) {
          navigate(u.pathname + u.search);
        } else {
          window.location.href = u.href;
        }
      } catch {
        window.location.href = dest.url;
      }
    } else {
      navigate(dest.path);
    }
  }

  useEffect(() => {
    const scanner = new Html5Qrcode('reader');
    scannerRef.current = scanner;
    let cancelled = false;

    scanner
      .start(
        { facingMode: 'environment' },
        { fps: 10, qrbox: { width: 240, height: 240 } },
        (decodedText) => {
          if (handledRef.current) return;
          const dest = resolveQr(decodedText);
          if (!dest) {
            setStatus(`QR lido, mas não reconhecido: "${decodedText.slice(0, 40)}…"`);
            return;
          }
          handledRef.current = true;
          setStatus('QR reconhecido! Abrindo…');
          void scanner.stop().finally(() => irPara(dest));
        },
        () => { /* ignora frames sem QR */ },
      )
      .then(() => { if (!cancelled) setStatus('Câmera ativa — aponte para o QR Code.'); })
      .catch(() => {
        setErro(
          'Não foi possível acessar a câmera. Permita o acesso ou use a digitação manual. ' +
          '(A câmera exige HTTPS ou localhost.)',
        );
        setStatus('');
      });

    return () => {
      cancelled = true;
      const s = scannerRef.current;
      if (s) {
        s.stop().catch(() => { /* ja parado */ });
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function abrirManual() {
    const val = manual.trim();
    if (!val) return;
    irPara(resolveQr(val) ?? { type: 'internal', path: `/v?peca=${encodeURIComponent(val)}` });
  }

  return (
    <>
      <TopBar>
        <Link className="btn" to="/">← Início</Link>
      </TopBar>

      <div className="container">
        <h1>Escanear QR Code</h1>
        <p className="sub">Aponte a câmera para o QR Code da etiqueta da peça.</p>

        <div className="card">
          <div id="reader" />
          {status && <div className="muted small" style={{ marginTop: 12 }}>{status}</div>}
          {erro && <div className="error-box small" style={{ marginTop: 12 }}>{erro}</div>}
        </div>

        <div className="card">
          <p className="small muted" style={{ margin: '0 0 10px' }}>Sem câmera? Digite o código manualmente:</p>
          <div className="row">
            <input
              type="text"
              placeholder="Ex.: P12345"
              value={manual}
              onChange={(e) => setManual(e.target.value)}
              onKeyDown={(e) => { if (e.key === 'Enter') abrirManual(); }}
              autoComplete="off"
            />
            <button className="primary" onClick={abrirManual}>Abrir</button>
          </div>
        </div>
      </div>
    </>
  );
}
